/** Тексти екранів платформи (українська; англійська — пізніше перекладом каталогів). */
export const platformText = {
  signInLink: 'Увійти',
  create: 'Створити',
  save: 'Зберегти',
  cancel: 'Скасувати',
  saved: 'Збережено',
  history: 'Журнал змін',
  historyCreated: 'створив(-ла) запис',
  historyEmpty: 'Змін ще немає',
  changedByColleague: 'Запис змінено — показано актуальні дані',
  conflictTitle: 'Поки ви редагували, поле змінили',
  takeTheirs: 'Взяти їхнє значення',
  keepMine: 'Залишити моє',
  forbidden: 'Недостатньо прав для цієї дії',
  notFound: 'Запис не знайдено або він вам недоступний',
  error: 'Не вдалося відкрити сторінку',
  retry: 'Ще раз',
  refreshFailed:
    'Не вдалося оновити дані. Показано останню завантажену версію, ваші зміни збережено в формі',
  slotUnavailable: 'Блок тимчасово недоступний. Оновіть сторінку',
  search: 'Пошук',
  automation: 'Автоматизація',
  formUnavailable: 'Не вдалося завантажити форму. Перевірте зв’язок і спробуйте ще раз',
  backToList: 'До списку',
  /** Запис без значень у полях заголовка (рядок списку, підпис чекбокса). */
  untitled: 'Без назви',
  yes: 'Так',
  no: 'Ні',
} as const;
